/// <amd-module name="Dashboards/WidgetHost/HostImplementation/DisabledWidgetHostImplementation" />
import { WidgetHostLoadOutcome } from "Dashboards/WidgetContracts/Internal/WidgetHostProps";
import { WidgetProps, WidgetSize } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { IVssComponentProperties } from "VSS/Platform/Layout";
import { WidgetHostImplementationBase, WidgetHostImplementationProps } from "./WidgetHostImplementationBase";

export interface DisabledWidgetHostProps extends WidgetHostImplementationProps, IVssComponentProperties {
    preDeterminedloadOutcome: WidgetHostLoadOutcome;
}

/**
 * The "Disabled Widget host" allows for standard widget Host overlay experiences along with caller-supplied error content, for widgets which are disabled outside of the normal contribution rendered flow.
 *
 */
export class DisabledWidgetHostImplementation extends WidgetHostImplementationBase<DisabledWidgetHostProps> {
    public componentDidMount() {
        super.componentDidMount();

        // All widgets, including disabled widgets still need to participate in standard dashboard level telemetry and bookkeeping
        // Report back with the outcome which was passed in at creation time.
        this.setPredeterminedOutcome(this.props.preDeterminedloadOutcome);
    }

    protected canConfigureWidget(): boolean {
        return false;
    }

    protected canCopyWidget(): boolean {
        return false;
    }

    protected getHostType(): string {
        return "DisabledWidgetHost";
    }

    protected renderWidgetHostImplementation(widgetProps: WidgetProps): JSX.Element {
        // Render the disabled experience supplied by the caller.
        return <>{this.props.children}</>;
    }

    protected getRenderSize(): WidgetSize {
        return this.props.convertToPixelSize(this.props.widgetProps.size);
    }

    protected canUseLightbox(): boolean {
        return false;
    }

    /** Renders a modern widget in the lightbox. */
    protected onShowLightbox = (): void => {
        throw Error("Lightbox is Not supported on disabled widgets."); // This is not a user facing path.
    };
}
